
export default function mock() {
    global.wx = {
        config() {
            console.log('wx.config');
        },
        ready(cb) {
            console.log('wx.ready');
            cb();
        },
        error(cb) {
            console.log('wx.error');
            // cb({ errMsg: 'config:fail' });
        },
        // 分享到朋友圈
        onMenuShareTimeline(res) {
            // console.log('share timeline', res);
        },
        // 分享给朋友
        onMenuShareAppMessage() {
        },
        // 分享给qq
        onMenuShareQQ() {
          console.log('我是qq');
        },
        // 分享给腾讯微博
        onMenuShareWeibo() {

        },
        // 分享到QQ空间
        onMenuShareQZone() {

        },
        closeWindow() {

        },
        chooseImage(src) {
            console.log('wx.chooseImage invoke');
            src.success({
                sourceType: 'camera',
                localIds: [
                    'http://static.playground.forzoom.tech/meta/hundred/bg1.png',
                ],
            });
        },
        uploadImage(src) {
            console.log('wx.uploadImage invoke');
            src.success({
                serverId: 'serverId',
            });
            // src.fail({
            //     errMsg: 'uploadImage:fail test',
            // });
        },
        previewImage() {
            console.log('wx.previewIamge invoke');
        },
        /**
         * 微信支付
         */
        chooseWXPay(res) {
            res.success({
                errMsg: 'chooseWXPay:ok',
            });
        },
        /**
         * 隐藏按钮
         */
        hideMenuItems() {
            console.log('wx.hideMenuItems');
        },
        /**
         * 显示按钮
         */
        showMenuItems() {
            console.log('wx.showMenuItems');
        },
        /**
         * 地理位置
         */
        getLocation(res) {
            res.success({
                longitude: 116.46,
                latitude: 39.92,
                speed: '10km/h',
                accuracy: '10km',
            });
        },
    };
}
